export default __webpack_public_path__ + "static/media/gambling.3729ef15.mp3";